import Dropdown from 'app/components/Dropdown';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { reportRedemptionHeader } from 'app/constants/table-header-constants';
import Csv from 'assets/images/csv-icon.svg';
import Excel from 'assets/images/xls-icon.svg';
import useRedemptionReport from './useRedemptionReport';
import Button from 'app/components/button';
import { commonMaxMonth } from 'app/utils/Parsers';

const RedemptionReport = () => {
  const {
    pageLoading,
    filteredData,
    paginationHandler,
    navigate,
    totalNumber,
    currentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    fetchReportData,
    mallList,
    values,
    setChange,
    handleSubmit,
    handleInput,
    bottomButtons,
  } = useRedemptionReport();

  if (!sectionObj) return null;

  const { sectionTitle, downloadObj } = sectionObj;

  return (
    <>
      <div className='cms-content__container'>
        <div className='cms-content__container billmanagement'>
          <div className='inner-form-wrapper flex flex-start flex-wrap mb-4 gap-3'>
            <div className='wd-25'>
              <Dropdown
                id='mallId'
                label='Mall name*'
                name='mallId'
                options={mallList || []}
                placeholder='Select Mall '
                value={values?.mallId || null}
                handleChange={setChange}
              />
            </div>
            <div className='wd-25 monthPicker'>
              <label>Select Month</label>
              <input
                id='selectedMonth'
                name='selectedMonth'
                type='month'
                className='monthPicker'
                value={values?.selectedMonth}
                max={commonMaxMonth()}
                onChange={(e) => setChange(e)}
              />
            </div>
            <div className='wd-25 flex align-items-center'>
              <Button
                onClick={handleSubmit}
                variant='Save'
                name='Submit'
                isDisabled={!values.mallId || !values.selectedMonth}
              />
            </div>
          </div>
          <div className='d-flex justify-content-between'>
            <h4 className='flex mb-0 align-items-center'>{sectionTitle}</h4>
            <div className='content-container__actionBox'>
              {downloadObj && (
                <>
                  <span
                    className='link cursor-pointer download'
                    onClick={(e) =>
                      downloadObj.csvClick && downloadObj.csvClick(e)
                    }
                  >
                    <img alt={'csv'} src={Csv} />
                  </span>
                  <span
                    className='link cursor-pointer download'
                    onClick={(e) =>
                      downloadObj.excelClick && downloadObj.excelClick(e)
                    }
                  >
                    <img alt={'excel'} src={Excel} />
                  </span>
                </>
              )}
            </div>
          </div>
          <PaginatedTable
            fulldata={filteredData}
            columns={reportRedemptionHeader}
            data={filteredData}
            currentPage={currentPage}
            dataPerPage={dataPerPage}
            pageCountNumber={pageCount}
            totalNumber={totalNumber}
            pageLoading={pageLoading}
            navigate={navigate}
            isLoading={pageLoading}
            paginationHandler={paginationHandler}
            fetchData={fetchReportData}
            values={values}
            handleInput={handleInput}
            bottomButtons={bottomButtons}
          />
        </div>
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default RedemptionReport;
